import {Types} from "../types";

import {Static} from "./static";

export const UseRef = ({
    next
}:{
    next : Types.Common.React.ChainServices.ChainServicesNode,
}) => <any>Static({
    getInitValue: () => {
        let value;
        return ({
            get: () => value,
            set: (v) => value = v,
        });
    },
    next,
});
